// --------------------------------------------------------------
// Created On: 2021-06-08
// Author: Zachary Thomas
//
// Last Modified: 2025-10-29
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../../components/Card/Card";
import Error from "../../../components/Error/Error";
import { Link } from "react-router-dom";
import PasswordInput from "../../../components/PasswordInput/PasswordInput";
import styles from "./EmailAndPasswordLoginForm.module.scss";

// Login form that allows a user to enter their email address and password.
export default function EmailAndPasswordLoginForm(props: Props): Component {
  // Check if the user pressed enter, if they did we attempt to login.
  function checkPressEnter(e: React.KeyboardEvent): void {
    if (e.key === "Enter") {
      props.onSubmit();
    }
  }

  return (
    <form className={styles.body} onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => checkPressEnter(e)}>
      <Card title="User Login">
        <div className="px-5 mb-4">
          <label className="mt-4">Email</label>

          <input
            data-test="login-email-input"
            type="email"
            className="form-control mt-2 mb-4"
            id="email-text"
            aria-describedby="Email"
            placeholder="Enter email address..."
            autoComplete="username"
            value={props.emailAddress}
            disabled={props.disabled}
            onChange={(e) => props.onChangeEmailAddress(e.target.value)}
          />

          <label className="mt-2">{props.isForgotPasswordRedirect && "Temporary"} Password</label>

          <PasswordInput
            password={props.password}
            disabled={props.disabled}
            onChangePassword={(password) => props.onChangePassword(password)}
          />

          {!props.isForgotPasswordRedirect && (
            <div className="my-2">
              <Link to="/forgot-password">Forgot your password?</Link>
            </div>
          )}

          {!props.isForgotPasswordRedirect && (
            <div className="my-2">
              <Link to="/register">Create a new account</Link>
            </div>
          )}

          <Error message={props.errorMessage} />

          <div className="text-center my-4">
            <button
              data-test="login-button"
              type="submit"
              id="submit-login"
              className={`${styles.btn} btn btn-primary`}
              disabled={props.disabled}
              onClick={() => props.onSubmit()}
            >
              Login
            </button>
          </div>
        </div>
      </Card>
    </form>
  );
}

interface Props {
  errorMessage: string;
  isForgotPasswordRedirect: boolean;
  emailAddress: string;
  password: string;
  disabled?: boolean;
  onChangeEmailAddress: (emailAddress: string) => void;
  onChangePassword: (password: string) => void;
  onSubmit: () => void;
}
